import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase configuration - will be loaded from backend settings
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || ''
};

// Initialize Firebase
let app = null;
let auth = null;
let googleProvider = null;

// Function to initialize Firebase with dynamic config
export const initializeFirebase = async (config) => {
  try {
    if (config && config.apiKey) {
      // Initialize Firebase with provided config
      app = initializeApp(config);
      auth = getAuth(app);
      googleProvider = new GoogleAuthProvider();
      
      // Configure Google provider
      googleProvider.setCustomParameters({
        prompt: 'select_account'
      });
      
      console.log('Firebase initialized successfully');
      return { success: true };
    } else {
      console.log('Firebase config not provided, skipping initialization');
      return { success: false, error: 'No Firebase configuration provided' };
    }
  } catch (error) {
    console.error('Firebase initialization error:', error);
    return { success: false, error: error.message };
  }
};

// Function to get Firebase instances
export const getFirebaseAuth = () => auth;
export const getGoogleProvider = () => googleProvider;
export const getFirebaseApp = () => app;

// Function to check if Firebase is initialized
export const isFirebaseInitialized = () => {
  return app !== null && auth !== null;
};

// Default export for backward compatibility
export default {
  initializeFirebase,
  getFirebaseAuth,
  getGoogleProvider,
  getFirebaseApp,
  isFirebaseInitialized
};
